import { Link } from "react-router-dom";
import {
  COUPLE_NAMES,
  HERO_IMAGE_URL,
  HOME_HERO_EYEBROW,
  WEDDING_DATE_LOCATION,
} from "../../constants/siteContent";

export default function HeroSection() {
  return (
    <section className="home-hero" aria-label="Wedding hero">
      <div className="home-hero-media" aria-hidden="true">
        <img
          src={HERO_IMAGE_URL}
          alt=""
          className="home-hero-img"
          width={1920}
          height={1080}
          decoding="async"
          fetchPriority="high"
        />
        <div className="home-hero-scrim" />
      </div>

      <div className="home-hero-inner">
        <p className="home-hero-eyebrow">{HOME_HERO_EYEBROW}</p>
        <h1 className="home-hero-title">{COUPLE_NAMES}</h1>
        <div className="home-hero-rule" aria-hidden="true" />
        <p className="home-hero-meta">{WEDDING_DATE_LOCATION}</p>
        <p className="home-hero-cta">
          <Link to="/save-the-date" className="home-hero-btn">
            Save the date
          </Link>
        </p>
      </div>

      <a href="#venue" className="home-hero-scroll-hint" aria-label="Scroll to venue details">
        <svg className="home-hero-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </a>
    </section>
  );
}
